import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "w-1/4 ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Search, {
      id: "filter-search",
      onInput: _ctx.onSearch,
      onClear: _ctx.clearSearch,
      value: _ctx.filter.search,
      class: "w-1/4 mb-1 rounded-md",
      placeholder: _ctx.$t('dashboard.filterHistoryHanging.searchPlaceholder'),
      isIconLeft: "",
      isIconClearRight: ""
    }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterDay, (row, index) => {
        return (_openBlock(), _createBlock("button", {
          key: index,
          onClick: ($event: any) => (_ctx.toggleActive(row.value)),
          class: ["rounded-md leading-tight px-2 align-middle font-semibold text-xs border h-10 w-16", _ctx.activeIndexes.includes(row.value) ? 'text-red-lp-100 font-semibold border-b-2 border-red-lp-100' : 'text-gray-lp-600 bg-white']
        }, _toDisplayString(row.name), 11, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_TimeRangePicker, {
        id: "filter-date-range-hanging-history",
        class: "my-2",
        placeholder: _ctx.$t('placeholderDatePicker'),
        default: _ctx.$t('hari ini'),
        startDate: _ctx.filter.startDate,
        endDate: _ctx.filter.endDate,
        maxDate: _ctx.maxDate,
        onSelect: _ctx.setDateRange,
        advanceStyle: {
          width: '490px'
        }
      }, null, 8, ["placeholder", "default", "startDate", "endDate", "maxDate", "onSelect"])
    ])
  ]))
}